import React from "react";

/*
 * Figures computed from the live production database on 20 July 2026:
 *   - total addresses:   SELECT count(*) FROM os_addressbase_core;
 *   - blocks of flats:   parents of 2+ residential (R*) child UPRNs
 *   - homes in blocks:   residential (R*) UPRNs with a parent_uprn
 *   - postcodes:         SELECT count(DISTINCT postcode) FROM os_addressbase_core;
 * The high-rise estimate is MHCLG's Building Safety Programme figure for
 * England (AddressBase carries no building-height attribute).
 */
const STATS = [
  {
    value: "33,587,544",
    label: "Addresses",
    detail: "Every Unique Property Reference Number issued across Great Britain.",
  },
  {
    value: "711,518",
    label: "Blocks of flats",
    detail: "Residential buildings containing two or more individual homes.",
  },
  {
    value: "5,942,263",
    label: "Homes inside blocks",
    detail: "Flats, maisonettes and units that share a building with their neighbours.",
  },
  {
    value: "1,709,348",
    label: "Postcodes",
    detail: "Full postcode coverage, from city towers to single-cottage lanes.",
  },
];

export default function StatsSection() {
  const statCards = STATS.map((stat) => (
    <div className="Stat-card" key={ stat.label }>
      <div className="Stat-card-value">{ stat.value }</div>
      <div className="Stat-card-label">{ stat.label }</div>
      <div className="Stat-card-detail">{ stat.detail }</div>
    </div>
  ));

  return (
    <section className="Section">
      <h2>Every block in Britain, catalogued</h2>
      <p className="Section-lede">
        This is a complete database of Great Britain&rsquo;s addresses — including
        every block of flats and the individual homes inside them, linked
        together by their UPRNs.
      </p>
      <div className="Stats-grid">
        { statCards }
      </div>
      <div className="Highlight-strip">
        <p>
          Looking for high-rises? England alone has an estimated{" "}
          <a
            href="https://mhclgmedia.blog.gov.uk/2024/04/09/explainer-data-supporting-governments-work-to-improve-building-safety/"
            target="_blank"
            rel="noreferrer"
          >12,500 residential buildings over 18 metres</a>{" "}
          (MHCLG estimate) — and every one of them has a UPRN you can find here.
          The single biggest block in the database is Nido Tower in Spitalfields,
          London, with 1,638 homes behind one front door.
        </p>
      </div>
      <p className="Stats-footnote">
        Figures computed from the live database, July 2026.
      </p>
    </section>
  );
}
